const bookFields = [
  {
    id: "book_id",
    numeric: true,
    disablePadding: false,
    label: "Book Id",
    width: "80px",
  },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
    width: "200px",
  },
  {
    id: "author",
    numeric: false,
    disablePadding: false,
    label: "Author",
    width: "200px",
  },
  {
    id: "type_name",
    numeric: false,
    disablePadding: false,
    label: "Type",
    width: "100px",
  },
  {
    id: "issued_name",
    numeric: false,
    disablePadding: true,
    label: "Issued To",
    width: "auto",
  },
];

export default bookFields;
